import React from 'react';
import PropTypes from 'prop-types';
import styles from './TextInput.module.scss';

const TextInput = ({
  label,
  name,
  value,
  onInput,
  isInError = false,
  styleOverride,
  placeholder = '',
}) => {
  return (
    <div className={styles.container}>
      <label htmlFor={name} className={`${styles.label}`}>
        {label}
      </label>
      <input
        id={name}
        name={name}
        className={`${styles.input} ${isInError ? styles.error : ''}`}
        value={value}
        onChange={e => onInput(e.target.value)}
        aria-describedby={isInError ? `${name}ErrorMessage` : undefined}
        aria-invalid={isInError ? 'true' : 'false'}
        styles={styleOverride}
        placeholder={placeholder}
      />
    </div>
  );
};

TextInput.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  onInput: PropTypes.func,
  isInError: PropTypes.bool,
};

export default TextInput;
